'use strict';
module.exports = require('./PrimeVue.js');